module.exports = __webpack_public_path__ + "ax.no2.18621ed8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ax.no2.jpg
// module id = qyjJ
// module chunks = 0